export default __webpack_public_path__ + "static/product_category_attached-ade8642872db7f3d4ac046f1262bef2a.jpg";